module.exports = __webpack_public_path__ + "static/img/banner_3.4764b3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/banner_3.png
// module id = eDnO
// module chunks = 1